export default __webpack_public_path__ + "img/10.76f8dab3.jpg";